import React from 'react'

import { Box, useTokens, Typography } from '@barracuda-internal/bds-core-v2'
import EmailInfo from 'components/pages/quarantineAction/EmailInfo'
import UserInfo from 'components/pages/quarantineAction/UserInfo'
import AllowActionContent from 'components/pages/quarantineAction/AllowActionContent'

const ContentHeader: React.FC<{
  user: string
  headerFrom: string
  content: { header: string; subHeader: string }
  info: string
  initial?: string
  date?: string
  subject?: string
}> = ({ user, headerFrom, content = { header: '', subHeader: '' }, info, initial, subject, date }) => {
  const tokens = useTokens()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 'fill',
        height: 'auto',
        gap: tokens.aliasesSpaceContainerSpacious
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: 'fixed',
          height: 'auto',
          gap: tokens.aliasesSpaceContainerDense
        }}
      >
        <Typography variant="h1" sx={{ textAlign: 'center' }}>
          {content.header}
        </Typography>
        <Typography variant="h4" sx={{ textAlign: 'center' }}>
          {content.subHeader}
        </Typography>
      </Box>
      {info === 'EmailInfo' && (
        <EmailInfo user={user} headerFrom={headerFrom} subject={subject || ''} date={date || ''} />
      )}
      {info === 'UserInfo' && <UserInfo user={user} headerFrom={headerFrom} initial={initial || ''} />}
      {info === 'AllowContent' && (
        <AllowActionContent
          subject={subject || ''}
          content={content}
          initial={initial || ''}
          headerFrom={headerFrom}
          user={user}
          date={date || ''}
        />
      )}
    </Box>
  )
}

export default ContentHeader
